import React, { useContext, useEffect, useState } from 'react';
import Results from './pages/Results';
import ReturningResults from './pages/ReturningResults';
import ReturningUser from './pages/ReturningUser';
import ReturningUserSuccess from './pages/ReturningUserSuccess';
import ReturnStep1 from './pages/ReturnStep1';
import Step0 from './pages/Step0';
import Step1 from './pages/Step1';
import Step2 from './pages/Step2';
import Step3 from './pages/Step3';
import { GlobalContext } from './reducers/global';
import langs from './translations/langs';

/**
 * @constant {Function} getQueryParams
 * @param {Object} x `window.location`
 * @returns {Object} - the query parameters from the given URL object
 */
const getQueryParams = (x) => new URLSearchParams(x.search);

function App() {
  let pageName = 'step0'

  const [page, setPage] = useState(pageName);

  const journey = getQueryParams(window.location).get('journey')

  const { dispatch } = useContext(GlobalContext);

  useEffect(() => {
    if (journey) {
      if (journey === 'new-user') pageName = 'step1'
      if (journey === 'returning-user') pageName = 'returningUser'
      setPage(pageName)
    }
    
    if (window && window.lxl_current_lang && window.lxl_current_lang.locale) {
      if (Object.keys(langs).includes(window.lxl_current_lang.locale)) {
        dispatch({
          type: 'OPTIONS_UPDATE',
          language: window.lxl_current_lang.locale,
        });
      }
    }

    // skip step0
    setPage('step1')
  }, [dispatch]);

  const PAGES = {
    step0: Step0,
    step1: Step1,
    step2: Step2,
    step3: Step3,
    results: Results,
    returningUser: ReturningUser,
    returningUserSuccess: ReturningUserSuccess,
    returnStep1: ReturnStep1,
    returningResults: ReturningResults,
  };

  const Page = PAGES[page];

  return <Page page={page} setPage={setPage} />;
}

export default App;
